const cjdr = {
  state: () => ({
    images: {
      sedans: [
        {
          modelName: "Dodge Charger",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2022_dodge-charger.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/26-dodge-charger.jpg"),
          angleViewAlt: require("../../../static/images/carcuts/cjdr/angle-view/26-dodge-alt.png"),
          trims: ["SXT", "GT", "Scat Pack", "SRT Hellcat Redeye Jailbreak", "RT", "Scat Pack Widebody", "SRT Hellcat Widebody Jailbreak",]
        }
      ],
      suvs: [
        {
          modelName: "Chrysler Pacifica",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2022_chrysler-pacifica.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/26-chrysler-pacifica.jpg"),
          angleViewAlt: require("../../../static/images/carcuts/cjdr/angle-view/26-chrysler-alt.png"),
          navDropdownImage: require("../../../static/images/carcuts/cjdr/nav-model-dropdown/26-pacifica-nav.png"),
          trims: ["Touring", "Touring L", "Limited", "Pinnacle"]
        },
        {
          modelName: "Jeep Grand Cherokee",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2023_jeep-grand-cherokee.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/26-jeep-grand-cherokee.jpg"),
          navDropdownImage: require("../../../static/images/carcuts/cjdr/nav-model-dropdown/25-grand-cherokee-nav.png"),
          trims: ["Laredo", "Altitude", "Limited", "Overland", "Summit", "Summit Reserve"]
        },
        {
          modelName: "Jeep Grand Cherokee L",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2023_jeep-grand-cherokee.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/26-jeep-grand-cherokee-l.jpg"),
          trims: ["Laredo", "Altitude", "Limited", "Overland", "Summit", "Summit Reserve"]
        },
        {
          modelName: "Wagoneer",
          // sideView: require("../../../static/images/carcuts/cjdr/angle-view/2023_jeep-grand-cherokee.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/26-wagoneer.jpg"),
          angleViewAlt: require("../../../static/images/carcuts/cjdr/angle-view/26-jeep-alt.png"),
          navDropdownImage: require("../../../static/images/carcuts/cjdr/nav-model-dropdown/24-wagoneer-nav.png"),
          trims: ["Laredo", "Altitude", "Limited", "Overland", "Summit", "Summit Reserve"]
        },
        {
          modelName: "Wagoneer L",
          // sideView: require("../../../static/images/carcuts/cjdr/angle-view/2023_jeep-grand-cherokee.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/26-wagoneer-l.jpg"),
          trims: ["Laredo", "Altitude", "Limited", "Overland", "Summit", "Summit Reserve"]
        },
        {
          modelName: "Grand Wagoneer",
          // sideView: require("../../../static/images/carcuts/cjdr/angle-view/2023_jeep-grand-cherokee.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/26-grand-wagoneer.jpg"),
          navDropdownImage: require("../../../static/images/carcuts/cjdr/nav-model-dropdown/24-grand-wagoneer-nav.png"),
          trims: ["Laredo", "Altitude", "Limited", "Overland", "Summit", "Summit Reserve"]
        },
        {
          modelName: "Grand Wagoneer L",
          // sideView: require("../../../static/images/carcuts/cjdr/angle-view/2023_jeep-grand-cherokee.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/26-grand-wagoneer-l.jpg"),
          trims: ["Laredo", "Altitude", "Limited", "Overland", "Summit", "Summit Reserve"]
        },
        {
          modelName: "Jeep Compass",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2022_jeep-compass.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/26-jeep-compass.jpg"),
          navDropdownImage: require("../../../static/images/carcuts/cjdr/nav-model-dropdown/25-compass-nav.png"),
          trims: ["Latitude Lux", "Sport", "Latitude", "Limited", "Trailhawk", "(Red)", "Altitude", "High Altitude"]
        },
        {
          modelName: "Jeep Cherokee",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2022_jeep-cherokee.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/26-jeep-cherokee.jpg"),
          trims: ["Altitude Lux", "Trailhawk"]
        },
        {
          modelName: "Jeep Wrangler",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2022_jeep-wrangler.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/26-jeep-wrangler.jpg"),
          navDropdownImage: require("../../../static/images/carcuts/cjdr/nav-model-dropdown/25-wrangler-nav.png"),
          trims: ["Sport", "Willys Sport", "Sport S", "Freedom", "Willys", "Sport Altitude", "Rubicon", "Sahara", "Sport RHD", "Sahara Altitude", "High Altitude", "Rubicon 392"]
        },
        {
          modelName: "Dodge Durango",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2022_dodge-durango.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/26-dodge-durango.jpg"),
          navDropdownImage: require("../../../static/images/carcuts/cjdr/nav-model-dropdown/25-durango-nav.png"),
          trims: ["SXT", "GT", "R/T", "R/T Hemi Orange", "Citadel", "SRT 392", "SRT Hellcat"]
        },
        {
          modelName: "Dodge Hornet",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2023_dodge-hornet.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/26-dodge-hornet.jpg"),
          navDropdownImage: require("../../../static/images/carcuts/cjdr/nav-model-dropdown/25-hornet-nav.png"),
          trims: ["GT Plus", "GT"]
        }
      ],
      trucks: [
        {
          modelName: "Jeep Gladiator",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2023_jeep-gladiator.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/26-jeep-gladiator.jpg"),
          navDropdownImage: require("../../../static/images/carcuts/cjdr/nav-model-dropdown/25-gladiator-nav.png"),
          trims: ["Sport", "Willys Sport", "Sport S", "Willys", "Freedom", "Overland", "Mojave", "Sahara", "Rubicon", "High Altitude"]
        },
        {
          modelName: "RAM 1500",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2022_ram-1500.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/26-ram-1500.jpg"),
          angleViewAlt: require("../../../static/images/carcuts/cjdr/angle-view/26-ram-alt.png"),
          navDropdownImage: require("../../../static/images/carcuts/cjdr/nav-model-dropdown/25-1500-nav.png"),
          trims: ["Limited", "Limited Longhorn", "Rebel", "Laramie", "Tradesman", "Tradesman HFE", "TRX"]
        },
        {
          modelName: "RAM 2500",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2022_ram-2500.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/26-ram-2500-3500.jpg"),
          navDropdownImage: require("../../../static/images/carcuts/cjdr/nav-model-dropdown/24-2500-nav.png"),
          trims: ["Tradesman", "Big Horn", "Laramie", "Power Wagon", "Limited Longhorn", "Limited"]
        },
        {
          modelName: "RAM 3500",
          sideView: require("../../../static/images/carcuts/cjdr/angle-view/2022_ram-2500.png"),
          angleView: require("../../../static/images/carcuts/cjdr/angle-view/26-ram-2500-3500.jpg"),
          navDropdownImage: require("../../../static/images/carcuts/cjdr/nav-model-dropdown/26-3500-nav.png"),
          trims: ["Tradesman", "Big Horn", "Laramie", "Power Wagon", "Limited Longhorn", "Limited"]
        }
      ],
      lifestyleImages: {
        defaultImage: require("../../../static/images/carcuts/cjdr/lifestyle/26-wrangler.jpg"),
        sedanImage: require("../../../static/images/carcuts/cjdr/lifestyle/26-challenger.png"),
        suvImage: require("../../../static/images/carcuts/cjdr/lifestyle/26-jeep.png"),
        truckImage: require("../../../static/images/carcuts/cjdr/lifestyle/26-ram.jpg"),
        altImage: require("../../../static/images/carcuts/cjdr/lifestyle/26-pacifica-alt.png")
      },
      videoLink: ["https://player.vimeo.com/progressive_redirect/playback/1189582169/rendition/2160p/file.mp4%20%282160p%29.mp4?loc=external&signature=c78baca21d097ac75ae0eccee2273f7c269547a8db7331c35f709119f8f47cdc"],
      roundButtons: [
        require("../../../static/images/buttons/round-buttons/chevy-New.png"), require("../../../static/images/buttons/round-buttons/chevy-Used.png"), require("../../../static/images/buttons/round-buttons/chevy-ScheduleService.png"), require("../../../static/images/buttons/round-buttons/chevy-Worth.png")
      ],
      browseButtons: [
        require("../../../static/images/buttons/browse-buttons/black-new.png"), require("../../../static/images/buttons/browse-buttons/black-used.png"), require("../../../static/images/buttons/browse-buttons/black-service.png"), require("../../../static/images/buttons/browse-buttons/black-specials.png")
      ],
      swoopIcons: [
        require("../../../static/images/buttons/swoop-icons/black01.png"), require("../../../static/images/buttons/swoop-icons/black03.png"), require("../../../static/images/buttons/swoop-icons/black02.png")
      ],
      homeBanners: [
        require("../../../static/images/banners/cjdr/CM-MC-26-CJDR-Established.jpg"), require("../../../static/images/banners/cjdr/CM-MC-26-CJDR-Lifestyle.jpg"), require("../../../static/images/banners/cjdr/CM-MC-26-CJDR-Modern.jpg"), require("../../../static/images/banners/cjdr/CM-MC-26-CJDR-Playful.jpg")
      ],
      stripBanners: [
        require("../../../static/images/banners/cjdr/SOKAL-SRS-120921-Ram1500-Established.jpeg"), require("../../../static/images/banners/cjdr/SOKAL-SRS-120921-Ram1500-Lifestyle.jpeg"), require("../../../static/images/banners/cjdr/SOKAL-SRS-120921-Ram1500-Modern.jpeg"), require("../../../static/images/banners/cjdr/SOKAL-SRS-120921-Ram1500-Playful.jpeg")
      ],
      logoExample: [
        require("../../../static/images/buttons/logos/dd-logo-cjdr.png"),
        require("../../../static/images/buttons/logos/dd-logo-mistu-w.png"),
        require("../../../static/images/buttons/logos/dd-logo-cjdr-w.png")
      ]
    },
   colors: {
      "--primary-color": "#ED0500",
      "--primary-dark": "#000",
      "--primary-light": "#FFF",
      "--secondary-color": "#ED0500",
      "--secondary-dark": "#000",
      "--secondary-light": "#fff",
    },
    fonts: {
      "--heading-text": "'Roboto', 'Helvetica Neue', Arial, sans-serif",
      "--subheading-text": "'Roboto', 'Helvetica Neue', Arial, sans-serif",
      "--body-text": "'Roboto', 'Helvetica Neue', Arial, sans-serif",
      "--bold-text": "'Roboto', 'Helvetica Neue', Arial, sans-serif",
      "--large-text" : "'Barlow Condensed', sans-serif"
    },
    borderRadius: {
      "--brand-br": "6px"
    }
  })
}


export default cjdr